var _rect, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundRobinAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#CDD7E1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9991,
    cy: 11.6671,
    r: 5.44444,
    fill: "#3F4F68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7397 24.0558C21.2199 26.4958 17.7862 27.9974 14.0017 27.9974C10.2172 27.9974 6.7834 26.4958 4.26367 24.0558C5.21981 22.0092 6.7186 20.3032 8.55724 19.4349C10.1588 18.6785 12.0183 18.6641 14.0017 18.6641C15.985 18.6641 17.8445 18.6785 19.4461 19.4349C21.2847 20.3032 22.7835 22.0092 23.7397 24.0558Z",
    fill: "#3F4F68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70272 14.0013L1.5549 17.1491C1.30093 16.1419 1.16602 15.0874 1.16602 14.0013C1.16602 6.91365 6.91169 1.16797 13.9993 1.16797C18.5916 1.16797 22.6205 3.58006 24.8882 7.2064M23.3419 14.0013L26.453 10.8902C26.701 11.8863 26.8327 12.9284 26.8327 14.0013C26.8327 21.089 21.087 26.8346 13.9993 26.8346C9.40707 26.8346 5.37816 24.4225 3.11046 20.7962",
    stroke: "#3F4F68",
    strokeWidth: 2.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundRobinAvatar);
export default __webpack_public_path__ + "static/media/round-robin-avatar.6ed945ef.svg";
export { ForwardRef as ReactComponent };